
import * as ipxRuntime$DJQ2mqktyh from '/codebuild/output/src149441126/src/github.com/ArchipelagoInternational/pba-template-frontend/node_modules/.pnpm/@nuxt+image@1.8.0_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "jpg",
    "png",
    "webp"
  ],
  "quality": 95
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$DJQ2mqktyh, defaults: {} }
}
        